import {Toast} from 'vant'
const JY_ENV = process.env.JY_ENV
let packageAxios = function (url, method, params, sdkfn) {
	return  new Promise(function(resolve, reject){
		let setParams = {}
		if (url && method) {
			setParams.url = url
			setParams.method = method
		}
		setParams = Object.assign(setParams, {
  			data: params || {},
  			success: function (res) {
  				if (res.errcode == 0) {
			        resolve(res)
			      } else if (res.errcode >= 11100 && res.errcode <= 11199) {
                    let isparams = window.location.href.split('?')[1],
                        getDomain = JY_ENV == 'sandBox' ? '//test-activity.100tal.com' : '//activity.100tal.com'
                    if (isparams) {
                    	window.location.href = getDomain + '/school?' + isparams
                    } else {
                    	window.location.href = getDomain + '/school'
                    }
			      } else {
		            Toast({
					  message: res.errmsg
					})
			        reject(res)
			      }
  			},
  			fail: function (res) {
		      let errInfo  = {
		      	errdata: res,
		      	errmsg: res.errmsg ? res.errmsg : '网络异常，请刷新重试！'
		      }
		      Toast({
					  message: errInfo.errmsg
					})
		      reject(errInfo)
		    },
		    complete: function (res) {
		      // typeof params.complete == "function" && params.complete(res)
		      // reject(res)
		    }
  		})
  		if (url && method) {
  			window.TAL_UC.setPassportAxiosRequest(setParams)
  		} else {
  			sdkfn(setParams)
  		}
  	})
}

export default packageAxios



// WEBPACK FOOTER //
// ./common/assets/js/packageAxios.js